export type Map<T = string> = {
  [id: string]: T;
};

export function getInitMap<T = string>(): Map<T> {
  return {};
}
